import { FormPayrollSettings } from "../../components/FormPayrollSettings";
import { usePayrollSettingsProgress } from "../../hooks/usePayrollSettingsProgress";

import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const PayrollSchedule: React.FC<FlowStep> = ({ onNext }) => {
  const { markPayrollScheduleSaved } = usePayrollSettingsProgress();

  const handleSuccess = () => {
    markPayrollScheduleSaved();
    onNext?.();
  };

  return <FormPayrollSettings onSuccess={handleSuccess} />;
};
